DialogOrdenesAddItemsCtrl.$inject = ['$log', '$scope', 'Orden', '$http', 'OrdenActionsService'];
export default function DialogOrdenesAddItemsCtrl($log, $scope, Orden, $http, OrdenActionsService) {
    var vm = this;

    vm.model = $scope.model;
    vm.dialogHandler = $scope.dialog;
    vm.cargando = {
        datos: false,
        submit: false
    };
    vm.ordenId = vm.model.ordenId;
    vm.modoEdicion = typeof vm.ordenId != 'undefined';
    vm.formDeshabilitado = false;
    vm.model.mantenerTareas = true;

    cargarOrdenes();

    function cargarOrdenes() {
        vm.cargando.datos = true;
        vm.formDeshabilitado = true;
        var promesa = Orden.get({cerrada: false}).$promise;
        promesa.then(function (data) {
            vm.ordenes = data.data;
            vm.cargando.datos = false;
            vm.formDeshabilitado = false;

            // if (vm.ordenes.length == 0) {
            //     vm.dialogHandler.cancel();
            //     $.toast({
            //         text: Lang.get('ordenes.mensaje_no_existen_ordenes'),
            //         showHideTransition: 'slide',
            //         icon: 'warning'
            //     });
            // }
        });
        return promesa;
    }

    vm.nuevaOrden = function () {
        OrdenActionsService.anyadirOrden().then(function (data) {
            cargarOrdenes().then(function (data2) {
                data2.data.forEach(function (item) {
                    if (item.id = data.id)
                        vm.model.ordenSeleccionada = item;
                })
            });

        })
    };

    function anyadirAOrden(ordenSeleccionada, codigos, tipoItem) {
        vm.cargando.submit = true;
        vm.formDeshabilitado = true;
        var ordenId = null;
        if (typeof ordenSeleccionada.id !== 'undefined')
            ordenId = ordenSeleccionada.id;

        var url = Sigo.var.path + '/ordenes/';
        var data = {
            orden_id: ordenId
        };
        if (tipoItem === 'incidencia') {
            url += 'anyadir-incidencias';
            data.codigos_incidencias = codigos
        } else if (tipoItem === 'tarea') {
            url += 'anyadir-tareas';
            data.codigos_tareas = codigos
        } else
            throw new Error('TipoItem no válido!');

        var promise = $http.post(url, data);
        promise.then(function (data) {
            var respuesta = data.data;

            Sigo.UI.Messages.procesarRespuestaMultiplesAcciones(respuesta);

            vm.dialogHandler.close(respuesta);
        });
    }

    function cambiarDeOrden(ordenSeleccionada, codigos) {
        vm.cargando.submit = true;
        vm.formDeshabilitado = true;
        var ordenId = null;
        if (typeof ordenSeleccionada.id !== 'undefined')
            ordenId = ordenSeleccionada.id;

        var url = Sigo.var.path + '/ordenes/cambiar-orden-tareas';
        var data = {
            old_orden_id: vm.ordenId,
            orden_id: ordenId,
            codigos_tareas: codigos,
            mantener_tareas: vm.model.mantenerTareas
        };

        var promise = $http.post(url, data);
        promise.then(function (data) {
            Sigo.UI.Messages.procesarRespuestaMultiplesAcciones(data.data);
            vm.dialogHandler.close(data);
        });
    }

    function mostrarAlerta(mensajes) {
        $.toast({loader: false, text: mensajes.join('\n'), icon: 'success', hideAfter: 5000});
    }

    vm.submit = function (ordenSeleccionada, modoEdicion, codigos, tipoItem) {
        return (modoEdicion) ? cambiarDeOrden(ordenSeleccionada, codigos) : anyadirAOrden(ordenSeleccionada, codigos, tipoItem);
    };

    vm.cancelar = function () {
        vm.dialogHandler.cancel();
    }
}